import InputLabel, { InputLabelSharedProps } from "../InputLabel/InputLabel"
import { FormGroup } from "react-bootstrap"
import { ClassProps } from "../../../utility/common/props"
import { FormGroupProps } from "react-bootstrap/FormGroup"
import CloseButton from "../../CloseButton/CloseButton"
import styles from "./VerticalInputGroup.module.scss"

export interface VerticalInputGroupProps extends InputLabelSharedProps {
    onDelete?: () => void
    disabled?: boolean
    /** Явный id кнопки удаления; иначе `${controlId}-remove-button`, если задан controlId */
    removeButtonTestId?: string
}

const VerticalInputGroup: React.FC<VerticalInputGroupProps & FormGroupProps & ClassProps> = props => {
    const { children, onDelete, className, controlId, disabled, removeButtonTestId, ...inputLabelProps } = props

    const closeButtonTestId = removeButtonTestId ?? (controlId ? `${controlId}-remove-button` : undefined)

    return (
        <FormGroup className={className} controlId={controlId}>
            <InputLabel {...inputLabelProps}>
                {onDelete && (
                    <CloseButton
                        onClick={onDelete}
                        disabled={disabled}
                        className={styles.closeBtn}
                        testId={closeButtonTestId}
                    />
                )}
            </InputLabel>
            {children}
        </FormGroup>
    )
}

export default VerticalInputGroup
